import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
/* empty css               */
function NoResults({ description = "", title = "", query = "" }) {
  return /* @__PURE__ */ React.createElement("div", { className: "no-results" }, /* @__PURE__ */ React.createElement(Heading, { variant: "medium", className: "no-results__title" }, title), /* @__PURE__ */ React.createElement("p", { className: "no-results__description" }, description.replace("{{searchQuery}}", `"${query}"`)));
}
export {
  NoResults,
  NoResults as default
};
//# sourceMappingURL=NoResults.js.map
